<script>
export default {
    name: "SearchIcon"
}
</script>
<template>
    <svg  role="img" aria-label="Search" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.0625 7.5625C5.0625 5.55859 6.15234 3.73047 7.875 2.71094C9.63281 1.69141 11.7773 1.69141 13.5 2.71094C15.2578 3.73047 16.3125 5.55859 16.3125 7.5625C16.3125 9.60156 15.2578 11.4297 13.5 12.4492C11.7773 13.4688 9.63281 13.4688 7.875 12.4492C6.15234 11.4297 5.0625 9.60156 5.0625 7.5625ZM6.15234 13.3281C7.41797 14.3125 9 14.875 10.6875 14.875C14.7305 14.875 18 11.6055 18 7.5625C18 3.55469 14.7305 0.25 10.6875 0.25C6.67969 0.25 3.375 3.55469 3.375 7.5625C3.375 9.28516 3.97266 10.8672 4.95703 12.1328L0.597656 16.4922L0 17.0898L1.19531 18.25L1.79297 17.6523L6.15234 13.293V13.3281Z" fill="#48707A"/>
    </svg>
</template>
